export default __webpack_public_path__ + "static/media/OrgLogo.fe614d18.png";